import 'leaflet/dist/leaflet.css';
import { useState, useEffect, ReactNode } from 'react'
import RotatedMarker from './RotatedMarker';
import useDroneHubConnection from '../hooks/DroneHubConnection';
import { HubMapPositionMessage, HubMapPositionSchema } from '../asp/DroneHub';
import OpenStreetMap from '../maps/OpenStreetMap';
import { GPSMapDroneIcon } from '../assets/icons/GPSMapIcons';

import "./Airmap.css"

function Airmap(): ReactNode {
    const droneHub = useDroneHubConnection();
    const [dronePosition, setDronePosition] = useState<HubMapPositionMessage | null>(null);

    const validPosition = {
        lat: dronePosition?.lat ?? 51.505,
        lng: dronePosition?.lng ?? 0.0,
        yaw: dronePosition?.yaw ?? 0
    };

    useEffect(() => {
        droneHub.connection.on('MapPosition', (message: HubMapPositionMessage) => {
            const result = HubMapPositionSchema.safeParse(message);
            if (result.success) {
                setDronePosition(result.data);
            } else {
                console.error(result.error);
            }
        });
    }, [droneHub]);

    return (
        <>
            <div className='airmap-container'>
                <OpenStreetMap
                    center={[validPosition.lat, validPosition.lng]}
                    zoom={13}
                    scrollWheelZoom={false}
                >
                    <RotatedMarker
                        position={[validPosition.lat, validPosition.lng]}
                        icon={GPSMapDroneIcon}
                        rotationAngle={validPosition.yaw}
                        style={{ backgroundColor: "#0037ffad", transform: 'rotate(50deg)' }}
                    />
                </OpenStreetMap>
            </div>
        </>
    )
}

export default Airmap;